.inputFeedback {
  display: flex;
  gap: 8px;
  margin-top: 4px;
  font-size: 11px;
}

.errorText {
  @include themify($themes) {
    color: themed("error-primary");
  }
}

.charCount {
  margin-left: auto;
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.validIcon {
  position: absolute;
  @include themify($themes) {
    color: themed("success-primary");
  }
}
